import { useMemo } from 'react';
import createDecorator from 'final-form-calculate';
import type { ListingResponse } from '../../../../models/propertiesList';

/**
 * Formats a listings address to match what is returned by the autocomplete, and maps it into an option to be rendered
 *
 * @returns {FormattedListing}
 */
export function formatListing(listing: ListingResponse) {
  const {
    address: { street, city, state, unit, zip },
    listingAlias,
  } = listing;
  const streetAddress = [street, unit].filter(Boolean).join(' ');
  const fullAddress = [streetAddress, city, state].filter(Boolean).join(', ');
  const fullAddressWithZip = [fullAddress, zip].filter(Boolean).join(' ');
  return { address: fullAddressWithZip, listingAlias };
}

/**
 * Keeps the listingAlias field updated, to match the address field
 * @param {FormattedListing[]} previouslyEnteredListings
 * @returns {import('final-form').Decorator}
 */
export function useAddressDecorator(previouslyEnteredListings: Array<{ address: string; listingAlias: string }>) {
  const addressDecorator = useMemo(() => {
    return createDecorator({
      field: 'fullAddress',
      updates: {
        listingAlias(fullAddressValue) {
          return (
            previouslyEnteredListings.find((listing) => listing.address === fullAddressValue)?.listingAlias ?? null
          );
        },
      },
    });
  }, [previouslyEnteredListings]);
  return addressDecorator;
}
